import { BotPartSlot } from '@nova/types';

export type BotSkinPartDefinition = {
  slot: BotPartSlot;
  /** Spine skeleton attachment name used during skin composition. */
  spinePartName: string;
};

/** Order used when composing bot skins onto the skeleton. */
export const BOT_SKIN_COMPOSITION_ORDER: readonly BotSkinPartDefinition[] = [
  { slot: BotPartSlot.TREADS, spinePartName: 'legs' },
  { slot: BotPartSlot.HELMET, spinePartName: 'helmet' },
  { slot: BotPartSlot.RUDDER, spinePartName: 'tail' },
  { slot: BotPartSlot.PLATFORM, spinePartName: 'body' }
];

/** Fixed order for bot part slots in datasets and asset prep. */
export const ORDERED_BOT_PART_SLOTS: readonly BotPartSlot[] = BOT_SKIN_COMPOSITION_ORDER.map(({ slot }) => slot);
